import * as tslib_1 from "tslib";
import { OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { CustomMessagesService } from '@core/errors/custom-messages.service';
import { ServiceProviderOrderByEnum } from '@core/interfaces';
import { getErrorCode } from '@core/utils/get-error-code';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { TranslateService } from '@ngx-translate/core';
import { CoordsValidation } from '@validators/coords-validation';
import { map } from 'lodash';
import { Subject } from 'rxjs';
import { sentry } from 'sentry';
import { VideoInfoModalService } from '../../../../core/components/video-info-modal/video-info-modal.service';
import { SECTOR_AND_ENVIRONMENT_ROLLOVER_DATE } from '../../../../core/consts';
import english from '../../i18n/en.json';
import spanish from '../../i18n/es.json';
import portuguese from '../../i18n/pt.json';
import { LocationService } from '../../services/location.service';
import { DialogAlertComponent } from '../dialog-alert/dialog-alert.component';
var DialogLocationsComponent = /** @class */ (function () {
    function DialogLocationsComponent(data, matDialogRef, fuseProgressBarService, authenticationService, customMessageService, locationsService, formBuilder, matDialog, translate, translationLoader, videoInfoModal) {
        this.data = data;
        this.matDialogRef = matDialogRef;
        this.fuseProgressBarService = fuseProgressBarService;
        this.authenticationService = authenticationService;
        this.customMessageService = customMessageService;
        this.locationsService = locationsService;
        this.formBuilder = formBuilder;
        this.matDialog = matDialog;
        this.translate = translate;
        this.translationLoader = translationLoader;
        this.videoInfoModal = videoInfoModal;
        this.isUpdate = false;
        this.isLoading = false;
        this.isViewMode = false;
        this.selectedTabIndex = 0;
        this.serviceProvidersSearchPerformed = false;
        this.serviceProvidersArray = [];
        this.loadingProviders = false;
        this.hasEditGroupPermission = false;
        this.hasLocationsPermissionsEnabled = true;
        this.sectorAndEnvironmentRollOverDate = SECTOR_AND_ENVIRONMENT_ROLLOVER_DATE;
        this.destroy$ = new Subject();
        this.location = this.data.location;
        this.isViewMode = this.data.isViewMode;
        this.translationLoader.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    DialogLocationsComponent.prototype.ngOnInit = function () {
        this.hasEditGroupPermission = this.authenticationService.hasPermission('groups-edit');
        this.hasLocationsPermissionsEnabled = this.authenticationService.hasAccountPreference({
            defaultIfUndefined: true,
            expectedValue: true,
            property: 'other',
            subProperty: 'featureLocationsPermissionsEnabled'
        });
        this.isUpdate = (this.location && this.location.id) ? true : false;
        this.locationForm = this.formBuilder.group({
            name: [this.location && this.location.name, [Validators.required, Validators.maxLength(100)]],
            locationGroup: [this.location && this.location.group, [Validators.required]],
            documentNumber: [(this.location && this.location.documentNumber) || '', [Validators.maxLength(14)]],
            address: this.formBuilder.group({
                countryCode: [null],
                postalCode: [(this.location && this.location.address && this.location.address.postalCode) || '', [Validators.maxLength(8)]],
                city: [this.location && this.location.address && this.location.address.city, [Validators.required]],
                state: [this.location && this.location.address && this.location.address.state, [Validators.required]],
                streetName: [(this.location && this.location.address && this.location.address.streetName)],
                number: [this.location && this.location.address && this.location.address.number],
                neighborhood: [this.location && this.location.address && this.location.address.neighborhood],
                formattedAddress: (this.location && this.location.address && this.location.address.formattedAddress),
                complement: (this.location && this.location.address && this.location.address.complement),
                coords: this.formBuilder.group({
                    latitude: [this.location && this.location.address && this.location.address.coords && this.location.address.coords.latitude, [Validators.required, CoordsValidation.validate]],
                    longitude: [this.location && this.location.address && this.location.address.coords && this.location.address.coords.longitude, [Validators.required, CoordsValidation.validate]]
                }),
            }),
            notes: (this.location && this.location.notes),
            segmentsId: [this.location && this.location.segments && this.location.segments.length ? this.location.segments : null],
            contact: this.formBuilder.group({
                emails: this.formBuilder.array((this.location && this.location.contact) && this.location.contact.emails ? this.location.contact.emails : []),
                phones: this.formBuilder.array((this.location && this.location.contact) && this.location.contact.phones ? this.location.contact.phones : [])
            }),
            serviceProviders: this.formBuilder.array([]),
            searchingWithGoogle: [true]
        });
        if (this.isViewMode) {
            this.locationForm.disable();
        }
    };
    DialogLocationsComponent.prototype.ngOnDestroy = function () {
        this.destroy$.next();
        this.destroy$.complete();
    };
    DialogLocationsComponent.prototype.onTabChange = function (event) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var tabCompaniesName;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        tabCompaniesName = this.translate.instant('LOCATIONS.DIALOG.TABS.COMPANIES');
                        if (!(event.tab.textLabel === tabCompaniesName && !this.serviceProvidersSearchPerformed)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.updateServiceProvidersFormArray()];
                    case 1:
                        _a.sent();
                        this.serviceProvidersSearchPerformed = true;
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    DialogLocationsComponent.prototype.fetchLocationServiceProviders = function (locationId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var limit, offset, hasNextPage, serviceProvidersArray, response, pageInfo, newServiceProviders;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!locationId) {
                            return [2 /*return*/, null];
                        }
                        limit = 100;
                        offset = 0;
                        hasNextPage = true;
                        serviceProvidersArray = [];
                        this.loadingProviders = true;
                        _a.label = 1;
                    case 1:
                        if (!hasNextPage) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.locationsService.getLocationServiceProviders({ locationId: locationId, limit: limit, offset: offset, orderBy: ServiceProviderOrderByEnum.segmentName_asc })];
                    case 2:
                        response = _a.sent();
                        pageInfo = response.serviceProvidersConnection.pageInfo;
                        newServiceProviders = response.serviceProvidersConnection.items;
                        serviceProvidersArray = serviceProvidersArray.concat(newServiceProviders);
                        hasNextPage = pageInfo.hasNextPage;
                        offset += limit;
                        return [3 /*break*/, 1];
                    case 3:
                        this.loadingProviders = false;
                        return [2 /*return*/, serviceProvidersArray];
                }
            });
        });
    };
    DialogLocationsComponent.prototype.updateServiceProvidersFormArray = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, serviceProvidersFormArray, serviceProviders;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.fetchLocationServiceProviders(this.location.id)];
                    case 1:
                        _a.serviceProvidersArray = _b.sent();
                        serviceProvidersFormArray = this.locationForm.get('serviceProviders');
                        serviceProvidersFormArray.clear();
                        serviceProviders = this.setServiceProvidersForm();
                        serviceProviders.forEach(function (provider) { return serviceProvidersFormArray.push(provider); });
                        return [2 /*return*/];
                }
            });
        });
    };
    DialogLocationsComponent.prototype.setServiceProvidersForm = function () {
        var _this = this;
        return this.serviceProvidersArray.map(function (serviceProvider) { return _this.formBuilder.group({
            segment: [serviceProvider.segment, [Validators.required]],
            company: [serviceProvider.company],
            maintenanceTypes: [serviceProvider.maintenancesTypes || []],
            deadlineContract: [serviceProvider.deadlineContract],
        }); });
    };
    DialogLocationsComponent.prototype.setServiceProvidersInput = function (serviceProviders) {
        if (!this.serviceProvidersSearchPerformed) {
            return null;
        }
        if (!this.location) {
            return null;
        }
        return serviceProviders.map(function (serviceProvider) { return ({
            segmentId: serviceProvider.segment && serviceProvider.segment.id,
            companyId: serviceProvider.company && serviceProvider.company.id,
            deadlineContractId: serviceProvider.deadlineContract && serviceProvider.deadlineContract.id,
            maintenanceTypeIds: map(serviceProvider.maintenanceTypes, 'id')
        }); });
    };
    DialogLocationsComponent.prototype.getInputToSave = function () {
        var locationFormValue = this.locationForm.getRawValue();
        var emails = locationFormValue.contact.emails
            .map(function (contactEmail) { return ({
            name: contactEmail.name,
            emailAddress: contactEmail.emailAddress,
            primary: contactEmail.primary,
            contactType: contactEmail.contactType
        }); });
        var phones = locationFormValue.contact.phones
            .map(function (contactPhone) { return ({
            name: contactPhone.name,
            number: contactPhone.number.replace(/[^0-9]/g, ''),
            primary: contactPhone.primary,
            contactType: contactPhone.contactType
        }); });
        var segmentIdsArray = locationFormValue.segmentsId ? locationFormValue.segmentsId.map(function (segment) { return segment.id; })
            : this.isUpdate ? [] : null;
        var address = locationFormValue.address;
        delete address.formattedAddress;
        delete address.countryCode;
        address.postalCode = (address.postalCode || '').replace(/[^0-9]/g, '');
        address.streetName = address.streetName || '';
        return {
            address: address,
            serviceProviders: this.setServiceProvidersInput(locationFormValue.serviceProviders),
            documentNumber: locationFormValue.documentNumber || null,
            name: locationFormValue.name,
            group: locationFormValue.locationGroup && locationFormValue.locationGroup.id,
            segments: segmentIdsArray,
            notes: locationFormValue.notes,
            contact: { emails: emails, phones: phones },
            archived: this.location && this.location.archived || false
        };
    };
    DialogLocationsComponent.prototype.saveLocation = function (_a) {
        var closeDialog = _a.closeDialog;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var locationInput, success, _b, err_1, code;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        locationInput = this.getInputToSave();
                        this.fuseProgressBarService.show();
                        this.isLoading = true;
                        success = false;
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, 4, 5]);
                        _b = this;
                        return [4 /*yield*/, this.locationsService.save(this.location && this.location.id, locationInput)];
                    case 2:
                        _b.location = _c.sent();
                        if (closeDialog) {
                            this.matDialogRef.close({ reload: true, location: this.location });
                            this.customMessageService.success('LOCATIONS.SUCCESS_MESSAGE');
                        }
                        success = true;
                        return [3 /*break*/, 5];
                    case 3:
                        err_1 = _c.sent();
                        success = false;
                        code = getErrorCode(err_1);
                        if (code === 'location_name_duplicated') {
                            this.locationForm.get('name').setErrors({
                                'location_name_duplicated': true
                            });
                            return [2 /*return*/];
                        }
                        if (code === 'location_document_number_duplicated') {
                            this.locationForm.get('documentNumber').setErrors({
                                'document_number_name_duplicated': true
                            });
                            return [2 /*return*/];
                        }
                        sentry.captureException(err_1);
                        this.customMessageService.error('LOCATIONS.ERROR_MESSAGE');
                        return [3 /*break*/, 5];
                    case 4:
                        this.isLoading = false;
                        this.fuseProgressBarService.hide();
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/, success];
                }
            });
        });
    };
    DialogLocationsComponent.prototype.archiveLocation = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var alertDialog, archived, location;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        alertDialog = this.matDialog.open(DialogAlertComponent, {
                            panelClass: 'dialog-alert'
                        });
                        return [4 /*yield*/, alertDialog.afterClosed().toPromise()];
                    case 1:
                        archived = _a.sent();
                        if (!archived) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.locationsService.archiveLocation(this.location.id)];
                    case 2:
                        location = _a.sent();
                        this.matDialogRef.close({ reload: true, location: location });
                        this.customMessageService.success('LOCATIONS.SUCCESS_MESSAGE');
                        return [2 /*return*/];
                }
            });
        });
    };
    DialogLocationsComponent.prototype.unarchiveLocation = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var location;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.locationsService.unarchiveLocation(this.location.id)];
                    case 1:
                        location = _a.sent();
                        this.matDialogRef.close({ reload: true, location: location });
                        this.customMessageService.success('LOCATIONS.SUCCESS_MESSAGE');
                        return [2 /*return*/];
                }
            });
        });
    };
    DialogLocationsComponent.prototype.continue = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var savedSuccessfully;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.selectedTabIndex !== 0) {
                            this.selectedTabIndex++;
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.saveLocation({ closeDialog: false })];
                    case 1:
                        savedSuccessfully = _a.sent();
                        if (savedSuccessfully) {
                            this.selectedTabIndex = 2;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    DialogLocationsComponent.prototype.openIntroVideoAndGotoLocationEnvironmentTab = function () {
        var label = document.querySelector('#links-tab-label');
        if (label) {
            label.click();
        }
        this.videoInfoModal.open({
            title: this.translate.instant('LOCATIONS.DIALOG.TABS.TAB_LINKS.INTRO_VIDEO.TITLE'),
            description: this.translate.instant('LOCATIONS.DIALOG.TABS.TAB_LINKS.INTRO_VIDEO.DESCRIPTION'),
            videoId: 'VQE_FyV8Gf0'
        });
    };
    return DialogLocationsComponent;
}());
export { DialogLocationsComponent };
